import httpClient from "../axios/interceptors";
import { AxiosResponse } from "axios";
import { API } from "./endpoint";

export interface TpZonePrice {
  /** ราคาดิบจาก API (legacy field จาก Thailand Post) */
  price: number;
  zone?: string;
  /** ชื่อตรง DB */
  api_transport_price?: number;
  add_on_api_transport_price?: number;
  transport_price?: number;
  /** alias เดิม */
  add_on_price?: number;
  price_with_add_on?: number;
}

export interface TpCheckPriceResponse {
  north: TpZonePrice;
  south: TpZonePrice;
  partner_transport_id: string | null;
  brand_id: string | null;
  brand_code: string | null;
  brand_logo: string | null;
}

export const checkThailandPostPrice = async (input: {
  factory_id: string;
  weight: number;
  destination_postcode_north: string;
  destination_postcode_south: string;
  type?: string;
}): Promise<TpCheckPriceResponse> => {
  const res: AxiosResponse<TpCheckPriceResponse> = await httpClient.post(API.tpCheckPrice, input);
  return res.data;
};
